import { render, staticRenderFns } from "./place-add-or-update.vue?vue&type=template&id=542987ff&lang=pug"
import script from "./place-add-or-update.vue?vue&type=script&lang=js"
export * from "./place-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./place-add-or-update.vue?vue&type=style&index=0&id=542987ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports